export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11563.ba00974c.jpg";